import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Heading,
  Text,
  Table,
  Caption,
  Tr,
  Td,
  Flex,
  Box,
  Anchor,
  Link
} from '../../components';
import Receipt from '../Receipt';
import messages from './messages';
import {
  orderConfirmationQuery_receiptPage,
  orderConfirmationQuery_order
} from '../../core-types';

type Props = {
  receiptPage: orderConfirmationQuery_receiptPage | null;
  order: orderConfirmationQuery_order;
};

const OrderConfirmation: FC<Props> = ({ order, receiptPage }) => {
  const quantity: number = order.orderLines.reduce((accum, orderLine) => {
    if (orderLine) {
      accum += orderLine.quantity;
    }
    return accum;
  }, 0);

  return (
    <Flex alignItems="center" column data-testid="OrderConfirmation">
      <Box>
        <Heading textAlign="center">
          {receiptPage && receiptPage.title ? (
            receiptPage.title
          ) : (
            <FormattedMessage {...messages.heading} />
          )}
        </Heading>

        {order.type === 'value_code' && (
          <Text as="p" textAlign="center">
            <FormattedMessage
              {...messages.giftCardDescription}
              values={{
                quantity,
                mail: (
                  <Text as="span" typoStyle="sm" color="primary">
                    {order.customerEmail}
                    <br />
                    <br />
                  </Text>
                )
              }}
            />
          </Text>
        )}

        <Text as="p" textAlign="center">
          <FormattedMessage {...messages.thanksForPurchase} />
        </Text>

        {order.valueCodes && order.valueCodes.length > 0 && (
          <Box mb="sm">
            <Table data-testid="OrderConfirmation__GiftCards">
              <Caption>
                <FormattedMessage
                  {...messages.giftCardListHeading}
                  values={{ quantity }}
                />
              </Caption>
              <tbody>
                {order.valueCodes.map(valueCode => {
                  if (!valueCode) {
                    return null;
                  }
                  return (
                    <Tr
                      key={valueCode.token}
                      data-testid="OrderConfirmation__GiftCards__GiftCard"
                    >
                      <Td>
                        <Text mute>
                          {valueCode.product && valueCode.product.name}
                        </Text>
                      </Td>
                      <Td textAlign="right">
                        <Link
                          route="giftcard"
                          params={{ token: valueCode.token }}
                          passHref
                        >
                          <Anchor>
                            <FormattedMessage {...messages.giftCardLink} />
                          </Anchor>
                        </Link>
                      </Td>
                    </Tr>
                  );
                })}
              </tbody>
            </Table>
            <ol />
          </Box>
        )}

        <Receipt order={order} showHeader={false} />
      </Box>
    </Flex>
  );
};

export default OrderConfirmation;
